import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-registers',
	templateUrl: './registers.component.html',
	styleUrls: ['./registers.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class RegistersComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}
}
